import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { Sprout } from "lucide-react";

interface BannerHeaderProps {
  title: string;
  expanded: boolean;
  onToggle: () => void;
}

export function BannerHeader({ title, expanded, onToggle }: BannerHeaderProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      className="flex w-full items-center justify-between"
    >
      <div className="flex items-center gap-1">
        <Sprout className="h-6 w-6 text-[#1f1e1d]" />
        <span className="text-[16px] font-bold leading-[22px] tracking-[-0.16px] text-[#1f1e1d]">
          {title}
        </span>
      </div>
      <ChevronDown
        className={cn(
          "h-6 w-6 text-[#58534c] transition-transform duration-200",
          !expanded && "rotate-180",
        )}
      />
    </button>
  );
}
